export { mergeQueryParameters } from './UriBuilder'
